<template>
  <div>Sync</div>
</template>

<script>
  export default {
  }
</script>

<style>
</style>
